import React, { useEffect, useState } from "react";
import styles from "./BoneCalib.module.scss";
import Axios from "../../../_services/caller.service";

//COMPONENTS
import Button from "../../UiComponents/Button";
import Loader from "../../UiComponents/loader/Loader";
import Success from "../../UiComponents/sucess/Success";
//IMG
import conduction from "../../../pics/ConductionOsseusePdf.png";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import imageCO from "../../../pics/ConductionOsseusePdf.png";
import imageDragon from "../../../pics/dragonFly.png";
import neuronalBone from "../../../pics/neuronal_bone.png";
//UTILS
import {
  displayCalibValue,
  ticksToDate,
  ticksToDateYearMonthDay,
} from "../../calibration/functionDataSorted";

import { decodedB64, encodedB64 } from "../../../CustomHooks/DecodedBase64";

//IMPORT EXPORT CALIB IN TXT
import download from "downloadjs";
import DropZone from "../../UiComponents/dropZone/DropZone";
import {
  convertDateToTicks,
  dateJavascriptToTicks,
} from "../../../utils/handleDateTicks";
import ModalConfirmRegisterNewValue from "./Modal/ModalConfirmRegisterNewValue";
import ModalComfirmImport from "./Modal/ModalComfirmImport";
import ModalNotGoodOupout from "./Modal/ModalNotGoodOupout";
import { toast } from "react-toastify";
import LoaderLogin from "../../UiComponents/loader/LoaderLogin";
import MiniCardToggle from "../../UiComponents/card/MiniCardToggle";
import { PermissionGate } from "../managePermissions/PermissionGate";
import { useTranslation } from "react-i18next";
import { computeCoCorrection, computeVocalCoCorrection, CO_VOCAL_RETVF } from "../../manageCO/configCO";

const BoneCalib = ({ cabId, setCabId, cabname, onCalibrationSaved }) => {
  const { t } = useTranslation();
  // CALIBRATION
  const generalValue = 20;
  const [calibTonal, setCalibTonal] = useState([]);
  const [calibVocal, setCalibVocal] = useState([0]);
  const [dateCalibration, setDateCalibration] = useState("");

  // SERIAL NUMBER CO AND SOUND CARD SERIAL
  const [serialNumber, setSerialNumber] = useState("");
  const [serialSoundcardNumber, setSerialSoundcardNumber] = useState("");
  const [importSerialNumber, setImportSerialNumber] = useState(true);
  const [importSoundcardSerial, setImportSoundcardSerial] = useState(true);

  const [editSerialNumber, setEditSerialNumber] = useState("");
  const [maj, setMaj] = useState(false);

  //DISPLAY
  const [displayBone, setDisplayBone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSucess] = useState(false);

  //LOADING

  const [loadingVoc, setloadingVoc] = useState(true);
  const [loadingTon, setloadingTon] = useState(true);
  const [loadingCalibrationTonalForDate, setLoadingCalibrationTonalForDate] =
    useState(true);
  const [loadingAllData, setLoadingAllData] = useState(true);
  //WARNING
  const [warningMessage, setWarningMessage] = useState("");

  //IMPORT EXPORT FILE TXT
  const [selectedFile, setSelectedFile] = useState();
  const [modalConfirmImport, setModalConfirmImport] = useState(false);
  const [modalConfirmRegisterNewValue, setModalConfirmRegisterNewValue] =
    useState(false);
  const [modalNotGoodOutpout, setModalNotGoodOutpout] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [isCheckedDateUpdate, setIsCheckedDateUpdate] = useState(false);
  const [previousCalibTonal, setPreviousCalibTonal] = useState([]);
  const [previousCalibVocal, setPreviousCalibVocal] = useState("");
  const [previousDateCalibration, setPreviousDateCalibration] = useState("");
  const [previousSerialNumber, setPreviousSerialNumber] = useState("");
  const [previousSerialSoundcardNumber, setPreviousSerialSoundcardNumber] =
    useState("");
  const [importedSerialNumber, setImportedSerialNumber] = useState("");
  const [importedSoundcardSerialNumber, setImportedSoundcardSerialNumber] =
    useState("");
  const [isImportMode, setIsImportMode] = useState(false);

  // Warning modal for values > 60 dB
  const [showDbWarning, setShowDbWarning] = useState(false);
  const [pendingDbChange, setPendingDbChange] = useState(null);

  // SONO MODE
  const [sonoMode, setSonoMode] = useState(false);
  const [sonoMeasures, setSonoMeasures] = useState(Array(11).fill(""));
  const [sonoVocalMeasure, setSonoVocalMeasure] = useState("");

  // CO LOOKUP FROM TABLE
  const [coSearchTerm, setCoSearchTerm] = useState("");
  const [coSearchResults, setCoSearchResults] = useState([]);
  const [showCoDropdown, setShowCoDropdown] = useState(false);
  const [allCoCalibrations, setAllCoCalibrations] = useState([]);
  const [assignedCoSerials, setAssignedCoSerials] = useState([]);

  const frequencies = [
    "125HZ",
    "250Hz",
    "500Hz",
    "750Hz",
    "1Khz",
    "1.5Khz",
    "2Khz",
    "3Khz",
    "4Khz",
    "6KHZ",
    "8KHZ",
  ];

  // FETCH ALL CO CALIBRATIONS FOR LOOKUP
  useEffect(() => {
    Axios.get("/getCoCalibrations")
      .then((response) => {
        setAllCoCalibrations(response.data.results || []);
      })
      .catch(() => {});
    Axios.get("/getAssignedCoSerials")
      .then((response) => {
        setAssignedCoSerials(response.data.assigned || []);
      })
      .catch(() => {});
  }, []);

  // SEARCH CO CALIBRATIONS (exclude already assigned to other cabines)
  const handleCoSearch = (term) => {
    setCoSearchTerm(term);
    if (term.trim().length === 0) {
      setCoSearchResults([]);
      setShowCoDropdown(false);
      return;
    }
    const assignedToOtherCabs = new Set(
      assignedCoSerials
        .filter((a) => String(a.cabId) !== String(cabId))
        .map((a) => a.serial)
    );
    const results = allCoCalibrations.filter(
      (co) =>
        co.serial.toLowerCase().includes(term.toLowerCase()) &&
        !assignedToOtherCabs.has(co.serial)
    );
    setCoSearchResults(results);
    setShowCoDropdown(results.length > 0);
  };

  // INJECT CO CALIBRATION DATA INTO FORM
  const injectCoCalibration = (co) => {
    setPreviousCalibTonal([...calibTonal]);
    setPreviousCalibVocal(calibVocal);
    setPreviousDateCalibration(dateCalibration);
    setPreviousSerialNumber(serialNumber);
    setPreviousSerialSoundcardNumber(serialSoundcardNumber);

    const tonalValues = co.calib_tonal ? co.calib_tonal.split(",") : [];
    setCalibTonal(tonalValues);
    setCalibVocal(co.calib_vocal || "0");
    setDateCalibration(co.date_calibration || "");
    setSerialNumber(co.serial || "");
    setSerialSoundcardNumber(co.soundcard_serial || "");
    setImportedSerialNumber(co.serial || "");
    setImportedSoundcardSerialNumber(co.soundcard_serial || "");
    setIsImportMode(true);
    setModalConfirmImport(true);
    setOverlay(true);

    setCoSearchTerm("");
    setCoSearchResults([]);
    setShowCoDropdown(false);
    toast.info(t("calibration_data.co_injected", { serial: co.serial, defaultValue: `Calibration CO ${co.serial} injectée` }));
  };

  useEffect(() => {
    if (cabId !== "") {
      const controller = new AbortController();
      const signal = controller.signal;

      const fetchTonal = Axios.get(`/calibrationTonal/${cabId}`, { signal })
        .then((response) => {
          setloadingTon(false);
          if (response.data.message === "aucune donnée") {
            setCalibTonal([
              "-200",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "-200",
              "-200",
            ]);
            setSerialNumber("");
            setSerialSoundcardNumber("");
          } else {
            const allValueBone = response.data.data;
            const serialNumber = displayCalibValue(
              allValueBone,
              "Bone_Serial"
            )[0];
            setSerialNumber(decodedB64(serialNumber));

            const serialNumberCard = displayCalibValue(
              allValueBone,
              "Bone_Soundcard_Serial"
            )[0];
            setSerialSoundcardNumber(decodedB64(serialNumberCard));

            const valueTonal = displayCalibValue(allValueBone, "Bone_Value");
            if (valueTonal.length >= 1) {
              const data = valueTonal[0].split(",");
              setCalibTonal(data);
            } else {
              setCalibTonal([
                "-200",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "0",
                "-200",
                "-200",
              ]);
            }

            const dateTonal = displayCalibValue(allValueBone, "Bone_Passed")[0];
            console.log(dateTonal);
            return dateTonal;
          }
        })
        .catch((error) => {
          console.log(error);
        });

      const fetchVocal = Axios.get(`/calibrationVocal/${cabId}`, { signal })
        .then((response) => {
          setloadingVoc(false);
          if (response.data.message === "aucune donnée") {
            setCalibVocal(["0"]);
          } else {
            const allValueBone = response.data.data;
            const valueVocal = displayCalibValue(allValueBone, "Bone_Value");
            if (valueVocal.length >= 1) {
              setCalibVocal(valueVocal[0]);
            } else {
              setCalibVocal(["0"]);
            }

            const dateVocal = displayCalibValue(allValueBone, "Bone_Passed")[0];

            return dateVocal;
          }
        })
        .catch((error) => {
          console.log(error);
        });

      Promise.all([fetchTonal, fetchVocal])
        .then(([dateTonal, dateVocal]) => {
          // Vérifier si toutes les dates sont présentes
          const allDatesExist = dateTonal && dateVocal;

          if (allDatesExist) {
            setDateCalibration(dateTonal); // Utiliser dateGeneral comme exemple
            setWarningMessage(""); // Pas de message d'avertissement nécessaire
            setLoadingCalibrationTonalForDate(false);
          } else {
            setDateCalibration("");
            setLoadingCalibrationTonalForDate(false);
            setCalibTonal([
              "-200",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "0",
              "-200",
              "-200",
            ]);
            setCalibVocal(["0"]);
          }
        })
        .finally(() => {
          setLoadingCalibrationTonalForDate(false);
        });

      return () => {
        controller.abort();
      };
    }
  }, [cabId, setCabId, maj]);

  //UPDATE CALIB TONAL STATE
  const updateFrequenciesValue = (id, e) => {
    const newValue = e.target.value;

    if (newValue !== '' && Math.abs(parseFloat(newValue)) > 60) {
      setPendingDbChange({ type: 'tonal', id, value: newValue });
      setShowDbWarning(true);
      return;
    }

    const newState = calibTonal.map((obj, index) => {
      if (id === index) {
        return newValue;
      }

      return obj;
    });

    setCalibTonal(newState);
  };

  const confirmDbWarning = () => {
    if (pendingDbChange) {
      if (pendingDbChange.type === 'tonal') {
        setCalibTonal(prev =>
          prev.map((obj, index) =>
            index === pendingDbChange.id ? pendingDbChange.value : obj
          )
        );
      } else if (pendingDbChange.type === 'vocal') {
        setCalibVocal(pendingDbChange.value);
      }
    }
    setShowDbWarning(false);
    setPendingDbChange(null);
  };

  const cancelDbWarning = () => {
    setShowDbWarning(false);
    setPendingDbChange(null);
  };

  const registerNewValueBone = () => {
    const finalSerialNumber = isImportMode
      ? importSerialNumber
        ? importedSerialNumber
        : previousSerialNumber
      : serialNumber;

    const finalSerialSoundcardNumber = isImportMode
      ? importSoundcardSerial
        ? importedSoundcardSerialNumber
        : previousSerialSoundcardNumber
      : serialSoundcardNumber;

    // Encodage en Base64 seulement si un numéro est fourni
    const serialNumberEncoded = finalSerialNumber
      ? encodedB64(finalSerialNumber)
      : "";
    const serialNumberSoundCardEncoded = finalSerialSoundcardNumber
      ? encodedB64(finalSerialSoundcardNumber)
      : "";

    const date =
      isCheckedDateUpdate || !dateCalibration
        ? convertDateToTicks()
        : dateCalibration; // date now or date old

    setLoading(true);
    //create catid if they don't exist in DB
    Axios.post(`/createCatid/${cabId}`)

      .then((response) => {
        toast.success(response.data.message);
        // if they exist or if they are created we register calib data
        Axios.put(`/newValueBoneGeneral/${cabId}`, {
          data: { generalValue: generalValue, date: date },
        })

          .then((response) => {
            setLoading(false);
          })
          .catch(function (error) {});
        Axios.put(`/newValueBoneTonal/${cabId}`, {
          data: { calibTonal: calibTonal, date: date },
        })

          .then((response) => {})
          .catch(function (error) {
            console.log(error);
          });
        Axios.put(`/newValueBoneVocal/${cabId}`, {
          data: { calibVocal: calibVocal, date: date },
        })

          .then((response) => {})
          .catch(function (error) {
            console.log(error);
          });

        Axios.put(`/newValueBoneSoundcardSerial/${cabId}`, {
          data: serialNumberSoundCardEncoded,
        })

          .then((response) => {})
          .catch(function (error) {
            console.log(error);
          });
        Axios.put(`/newValueBoneSerial/${cabId}`, {
          data: serialNumberEncoded,
        })

          .then((response) => {
            setOverlay(false); // dans le cas d'import
            setModalConfirmImport(false); // dans le cas d'import
            setModalConfirmRegisterNewValue(false); // dans le cas de nouvelle valeur
            setMaj(!maj);

            toast.success(t("calibration_data.all_data_saved"));
            if (onCalibrationSaved) onCalibrationSaved();
          })
          .catch(function (error) {
            console.log(error);
          });
      })
      .catch(function (error) {
        if (error.response) {
          // Si une réponse avec un message d'erreur est reçue du backend
          const errorMessage = error.response.data.message;

          toast.error(errorMessage, {
            autoClose: false,
          });
        } else {
          toast.error(
            t("calibration_data.error_occurred"),
            {
              autoClose: false,
            }
          );
        }
      });
  };

  const checkHandler = () => {
    setIsCheckedDateUpdate(!isCheckedDateUpdate);
  };

  //IMPORT AND EXPORT CALIBRATION DATA
  const exportCalibDataBone = async () => {
    const calibDate = ticksToDateYearMonthDay(dateCalibration);

    // Create a TXT file
    const data = {
      Eoutpout: "Bone",
      date: dateCalibration,
      general: generalValue,
      vocal: calibVocal,
      tonal: calibTonal,
      serialNumber: serialNumber, // Add serial number
      serialSoundcardNumber: serialSoundcardNumber, // Add soundcard serial number
    };
    // Bone Calibration Data Ref - 221572109 - DFCB0100136098 - 12_10_2023
    const dataStr = JSON.stringify(data);
    const filename = `Bone Calibration Data - ${serialNumber} - ${serialSoundcardNumber} - [${cabname}(${cabId})] - ${calibDate}.txt`;
    const filetype = "text/plain";

    // Download the file
    download(dataStr, filename, filetype);
  };

  const fileChangedHandler = (file) => {
    setSelectedFile(file);
  };

  useEffect(() => {
    if (selectedFile) {
      importCalibDataBone();
    }
  }, [selectedFile]);

  const importCalibDataBone = () => {
    const reader = new FileReader();

    reader.onload = async (e) => {
      // Lecture du fichier importé
      const text = e.target.result;
      const data = JSON.parse(text);

      if (data.Eoutpout !== "Bone") {
        setModalNotGoodOutpout(true);
        setOverlay(true);
        return;
      }

      // Récupération des données importées
      const boneTonal = data.tonal;
      const boneVocal = data.vocal;
      const date = data.date;
      const importedSerial = data.serialNumber || "";
      const importedSoundcardSerial = data.serialSoundcardNumber || "";

      // Sauvegarde des anciennes valeurs AVANT d'afficher les nouvelles
      setPreviousCalibTonal([...calibTonal]);
      setPreviousCalibVocal(calibVocal);
      setPreviousDateCalibration(dateCalibration);
      setPreviousSerialNumber(serialNumber);
      setPreviousSerialSoundcardNumber(serialSoundcardNumber);

      if (importedSerial) {
        setSerialNumber(importedSerial);
      }
      if (importedSoundcardSerial) {
        setSerialSoundcardNumber(importedSoundcardSerial);
      }

      // Stocke les valeurs importées
      setImportedSerialNumber(importedSerial);
      setImportedSoundcardSerialNumber(importedSoundcardSerial);

      // Mettre à jour les données de calibration dans BoneCalib
      setCalibTonal(boneTonal);
      setCalibVocal(boneVocal);
      setDateCalibration(date);
      setIsImportMode(true); // On active le mode import
      // Ouvrir la modale pour confirmer l'importation
      setModalConfirmImport(true);
      setOverlay(true);
    };

    reader.readAsText(selectedFile);
  };

  const handleSerialNumberChange = (
    importSerialNumber,
    importSoundcardSerial
  ) => {
    setSerialNumber(
      importSerialNumber ? importedSerialNumber : previousSerialNumber
    );
    setSerialSoundcardNumber(
      importSoundcardSerial
        ? importedSoundcardSerialNumber
        : previousSerialSoundcardNumber
    );
  };

  // Surveiller tous les états de chargement
  useEffect(() => {
    if (!loadingTon && !loadingVoc && !loadingCalibrationTonalForDate) {
      setLoadingAllData(false); // Tout est chargé
    }
  }, [loadingCalibrationTonalForDate, loadingTon, loadingVoc]);

  return (
    <>
      {loadingAllData && <LoaderLogin />}

      {/* /********************IMPORT EXPORT */}

        <div className={styles.containerBoneCalib}>
          {overlay && <div className={styles.overlay}></div>}

          {showDbWarning && (
            <>
              <div className={styles.dbWarningOverlay} onClick={cancelDbWarning} />
              <div className={styles.dbWarningModal}>
                <button className={styles.dbWarningClose} onClick={cancelDbWarning}>
                  <AiOutlineClose />
                </button>
                <h4 className={styles.dbWarningTitle}>
                  <BsExclamationTriangleFill style={{ color: '#f59e0b' }} />
                  {t("calibration_data.warning")}
                </h4>
                <p className={styles.dbWarningText}>
                  {t("calibration_data.db_value_warning", { value: pendingDbChange?.value })}
                </p>
                <p className={styles.dbWarningText}>{t("calibration_data.confirm_apply_value")}</p>
                <div className={styles.dbWarningActions}>
                  <button className={styles.dbWarningCancel} onClick={cancelDbWarning}>{t("common.cancel")}</button>
                  <button className={styles.dbWarningConfirm} onClick={confirmDbWarning}>{t("common.confirm")}</button>
                </div>
              </div>
            </>
          )}

           <img className={styles.currentCalibrationImg} src={neuronalBone} alt="" />
          <div className={styles.cabnameAndType}>
          <h2>Calibration CO ➡️ </h2>
          <h3>
            {cabname}({cabId})
          </h3>
</div>

          <div className={styles.containerBtnExport}>
               <PermissionGate actionKey="cabines.transducers.calibration.export">
            <Button
              onPress={exportCalibDataBone}
              styles={"btnExport"}
              text={t("calibration_data.export")}
            /></PermissionGate>
            <div className={styles.containerImport}>
              <div className={styles.containerInputImport}>
          <label className={styles.uploadLabel}>
                           {t("calibration_data.select_file")}
                           <PermissionGate actionKey="cabines.transducers.calibration.import">
                             <input
                               type="file"
                               onChange={(e) => fileChangedHandler(e.target.files[0])}
                               className={styles.hiddenInput}
                             />
                           </PermissionGate>
                         </label>
             
              </div>
            </div>
          </div>

          {/* CO LOOKUP FROM TABLE */}
          <PermissionGate actionKey="cabines.transducers.calibration.import">
            <div className={styles.coLookupContainer}>
              <h5>{t("calibration_data.inject_from_co_table", { defaultValue: "Injecter depuis le tableau CO" })}</h5>
              <div className={styles.coSearchWrapper}>
                <input
                  type="text"
                  className={styles.coSearchInput}
                  value={coSearchTerm}
                  onChange={(e) => handleCoSearch(e.target.value)}
                  onFocus={() => {
                    if (coSearchResults.length > 0) setShowCoDropdown(true);
                  }}
                  onBlur={() => setTimeout(() => setShowCoDropdown(false), 200)}
                  placeholder={t("calibration_data.search_co_serial", { defaultValue: "Rechercher un n° de série CO..." })}
                />
                {showCoDropdown && (
                  <ul className={styles.coDropdown}>
                    {coSearchResults.map((co) => (
                      <li
                        key={co.serial}
                        className={styles.coDropdownItem}
                        onMouseDown={() => injectCoCalibration(co)}
                      >
                        <strong>{co.serial}</strong>
                        <span className={styles.coDropdownSub}>
                          {t("calibration_data.soundcard_serial", { defaultValue: "Carte son" })}: {co.soundcard_serial || "-"}
                        </span>
                        <span className={styles.coDropdownSub}>
                          {co.date_calibration || "-"}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </PermissionGate>

          {modalNotGoodOutpout && (
            <ModalNotGoodOupout
              setOverlay={setOverlay}
              setModalNotGoodOutpout={setModalNotGoodOutpout}
            />
          )}

          {/* {modalConfirmImport && (
            <ModalComfirmImport
              setModalConfirmImport={setModalConfirmImport}
              setOverlay={setOverlay}
              isCheckedDateUpdate={isCheckedDateUpdate}
              checkHandler={checkHandler}
              setMaj={setMaj}
              maj={maj}
              registerNewValue={registerNewValueBone}
            />
          )} */}
          {/* /********************IMPORT EXPORT */}
   
          <div className={styles.tonalHeader}>
            <h5>{t("calibration_data.tonal_correction")}</h5>
            <button
              type="button"
              className={sonoMode ? styles.sonoToggleBtnActive : styles.sonoToggleBtn}
              onClick={() => {
                if (!sonoMode) {
                  setSonoMeasures(frequencies.map(() => ""));
                  setSonoVocalMeasure("");
                }
                setSonoMode((prev) => !prev);
              }}
            >
              {sonoMode ? t("co.mode_direct", "Saisie directe valeurs sonomètre") : t("co.mode_sonometer", "Mesure sonomètre")}
            </button>
          </div>
          <div className={styles.tableScroll}>
            <table className={styles.calibTable}>
              <thead>
                <tr>
                  {sonoMode && <th className={styles.sonoRowLabel}></th>}
                  {frequencies.map((freq, index) => (
                    <th key={index}>{freq}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sonoMode ? (
                  <>
                    <tr>
                      <td className={styles.sonoRowLabel}>Mesure</td>
                      {sonoMeasures.map((measure, index) => (
                        <td key={index}>
                          <input
                            type="number"
                            step="0.1"
                            className={styles.sonoInputCalib}
                            value={measure}
                            onWheel={() => document.activeElement.blur()}
                            onChange={(e) => {
                              const val = e.target.value;
                              const updated = [...sonoMeasures];
                              updated[index] = val;
                              setSonoMeasures(updated);
                              const correction = computeCoCorrection(val, index);
                              setCalibTonal((prev) =>
                                prev.map((v, i) => i === index ? (correction || "-200") : v)
                              );
                            }}
                          />
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <td className={styles.sonoRowLabel}>Correction</td>
                      {calibTonal.map((value, index) => (
                        <td key={index} className={styles.sonoCorrection}>
                          {value || "-200"}
                        </td>
                      ))}
                    </tr>
                  </>
                ) : (
                  <tr>
                    {calibTonal.map((value, index) => (
                      <td key={index}>
                        <input
                          onChange={(e) => updateFrequenciesValue(index, e)}
                          onWheel={() => document.activeElement.blur()}
                          type="number"
                          min="-200"
                          max="200"
                          step="0.1"
                          value={value}
                        />
                      </td>
                    ))}
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className={styles.containerVocale}>
            <h4>{t("calibration_data.vocal")}</h4>
            {sonoMode ? (
              <div className={styles.sonoVocalWrapper}>
                <div className={styles.sonoVocalRow}>
                  <span className={styles.sonoRowLabel}>Mesure</span>
                  <input
                    type="number"
                    step="0.1"
                    className={styles.sonoInputCalib}
                    value={sonoVocalMeasure}
                    onWheel={() => document.activeElement.blur()}
                    onChange={(e) => {
                      setSonoVocalMeasure(e.target.value);
                      const correction = computeVocalCoCorrection(e.target.value, CO_VOCAL_RETVF);
                      setCalibVocal(correction || "-200");
                    }}
                  />
                </div>
                <div className={styles.sonoVocalRow}>
                  <span className={styles.sonoRowLabel}>Correction</span>
                  <span className={styles.sonoCorrection}>{calibVocal || "-200"}</span>
                </div>
              </div>
            ) : (
              <input
                onChange={(e) => {
                  const val = e.target.value;
                  if (val !== '' && Math.abs(parseFloat(val)) > 60) {
                    setPendingDbChange({ type: 'vocal', value: val });
                    setShowDbWarning(true);
                    return;
                  }
                  setCalibVocal(val);
                }}
                onWheel={() => document.activeElement.blur()}
                type="number"
                step="0.1"
                value={calibVocal}
              />
            )}
          </div>
          <div className={styles.containerAllSerial}>
            <div className={styles.containerSerial}>
              <div className={styles.serial}>
                <h4>{t("calibration_data.bone_serial")}</h4>
                <input
                  onChange={(e) => setSerialNumber(e.target.value)}
                  type="text"
                  value={serialNumber}
                ></input>
                <img src={imageCO} alt="" />
              </div>

              <div className={styles.serial}>
                <h4>{t("calibration_data.soundcard_serial")}</h4>
                <input
                  onChange={(e) => setSerialSoundcardNumber(e.target.value)}
                  type="text"
                  value={serialSoundcardNumber}
                ></input>
                <img src={imageDragon} alt="" />
              </div>
            </div>
          </div>
          <div className={styles.containerBtn}>
            <div className={styles.useCurrentDate}></div>
             <PermissionGate actionKey="cabines.transducers.calibration.update">
            <Button
              onPress={() => {
                setOverlay(true);
                setModalConfirmRegisterNewValue(true);
                setIsImportMode(false);
              }}
              styles={"btnValidation"}
              text={t("calibration_data.save_new_values")}
            />
</PermissionGate>
            {(modalConfirmRegisterNewValue || modalConfirmImport) && (
              <ModalConfirmRegisterNewValue
                setModalConfirmImport={setModalConfirmImport}
                setModalConfirmRegisterNewValue={
                  setModalConfirmRegisterNewValue
                }
                setOverlay={setOverlay}
                isCheckedDateUpdate={isCheckedDateUpdate}
                checkHandler={checkHandler}
                importSerialNumber={importSerialNumber}
                setImportSerialNumber={setImportSerialNumber}
                importSoundcardSerial={importSoundcardSerial}
                setImportSoundcardSerial={setImportSoundcardSerial}
                registerNewValue={registerNewValueBone}
                // Passer les setters pour restaurer en cas d'annulation
                setCalibTonal={setCalibTonal}
                setCalibVocal={setCalibVocal}
                setDateCalibration={setDateCalibration}
                setSerialNumber={setSerialNumber}
                setSerialSoundcardNumber={setSerialSoundcardNumber}
                // Passer les anciennes valeurs sauvegardées
                previousCalibTonal={previousCalibTonal}
                previousCalibVocal={previousCalibVocal}
                previousDateCalibration={previousDateCalibration}
                previousSerialNumber={previousSerialNumber}
                previousSerialSoundcardNumber={previousSerialSoundcardNumber}
                importedSerialNumber={importedSerialNumber} // Ajout de la nouvelle variable
                importedSoundcardSerialNumber={importedSoundcardSerialNumber} // Ajout de la nouvelle variable
                handleSerialNumberChange={handleSerialNumberChange}
                isImportMode={isImportMode}
                maj={maj}
                setMaj={setMaj}
              />
            )}

            {loading && <Loader />}
            {success && <Success success={t("calibration_data.calibration_data_updated")} />}
          </div>
        </div>

    </>
  );
};

export default BoneCalib;
